import type { PlayerDetailsSelectOption } from '../types'

const toOptions = (
  labels: ReadonlyArray<string>
): ReadonlyArray<PlayerDetailsSelectOption> =>
  labels.map((label) => ({ label, value: label }))

/*
 * Option lists for the admin-only selects. Values are the labels themselves
 * until the API publishes its own enums for these fields — see
 * `adminFieldMap.ts`.
 */

export const PREFERRED_POSITION_OPTIONS = toOptions([
  'Forward',
  'Defence',
  'Goalie',
])

export const SKILL_LEVEL_OPTIONS = toOptions([
  'Beginner',
  'Intermediate',
  'Advanced',
  'Elite',
])

export const APPAREL_SIZE_OPTIONS = toOptions([
  'XS',
  'S',
  'M',
  'L',
  'XL',
  'XXL',
])

export const HEARD_ABOUT_US_OPTIONS = toOptions([
  'Friend',
  'Social Media',
  'Search Engine',
  'Rink Signage',
  'Other',
])
